export enum AgendaRangeTypes {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}
